import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeHu from '@angular/common/locales/hu';

// Az Angular date/number pipe-ok magyar formázása (LOCALE_ID: hu)
registerLocaleData(localeHu, 'hu');
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { SziromPreset } from './core/theme/szirom.preset';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MxCoreModule } from './core/mx.core.module';
import { MxSharedModule } from './shared/mx.shared.module';

// Application Components
// Application services
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MxCoreModule,
    MxSharedModule,
  ],
  declarations: [AppComponent],
  providers: [
    providePrimeNG({
      ripple: true,
      inputVariant: 'outlined',
      theme: {
        preset: SziromPreset,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
